(function() {
    'use strict';
    angular.module('cabinFlightAdmin').factory('CabinFlightAdminFactory', CabinFlightAdminFactory);

    function CabinFlightAdminFactory() {
        function SearchCabinRequest() {
            this.fromDate = null;
            this.toDate = null;
            this.approved = null;
            this.crewTypeCode = null;
            //this.crewName = null;
            this.crewId = null;
            this.origin = null;
            this.destination = null;
            this.department = null;
            this.profileId = null;
        }

        function FlightReportTabData() {
            this.inBoundDate = null;
            this.inBoundDestination = null;
            this.inBoundOrigin = null;
            this.inBoundACReg = null;
            this.intermediateFlights = [],
            this.outBoundDate = null;
            this.outBoundDestination = null;
            this.outBoundOrigin = null;
            this.outBoundACReg = null;
            this.cateringSales = 0;
            this.dutyFreeSales = 0;
            this.fwdTrolly = 0;
            this.aftTrolly = 0;
            this.inBoundInfoCollection = null;
            this.outBoundInfoCollection = null;
            this.targetAchieved = false;
        }

        function InBoundInfoCollection() {

            // Special service
            this.pregnantCount = 0;
            this.wchcCount = 0;
            this.deporteeCount = null
            this.otherSpecialPaxCount = 0;
            this.mailConsigner = null;
            this.mailConsignee = null;
            this.mailHanded = null;
            this.mailRefNo = null;

            // remarks
            this.remarks = null;

            // Flight Punctuality
            this.cleaningStartTime = null;
            this.cleaningCompletedTime = null;
            this.bordingClearenceTime = null;
            this.firstPaxBordingTime = null;
            this.lastPaxBordingTime = null;
            this.doorClosingTime = null;
            this.mailDeliveredAt = null;
            this.paxCount = null;
            this.briefingSrartTime = null;
            this.boardedToFirstBusTime = null;
            this.boardedToSecondBusTime = null;
            this.doorOpenedTime = null;
            this.landingTime = null;
            this.lastPaxDisembakedTime = null;
            this.pax = null;
            this.flightNo = null;
            this.landingSchdTime = null;
            this.lastPaxDisembakedSchdTime = null;
            this.bordingClearenceSchdTime = null;
            this.cleaningStartSchdTime = null;
            this.cleaningCompletedSchdTime = null;
            this.firstPaxBordingSchdTime = null;
            this.lastPaxBordingSchdTime = null;
            this.doorClosingSchdTime = null;
            this.briefingSrartSchdTime = null;
            this.boardedToFirstBusSchdTime = null;
            this.boardedToSecondBusSchdTime = null;
            this.doorOpenedSchdTime = null;
            this.cabinFlightDelayCollection = null;
            this.sno1Required = false;
            this.sno2Required = false;
        }

      function IntBoundInfoCollection() {

        // Special service
        this.pregnantCount = 0;
        this.wchcCount = 0;
        this.deporteeCount = null;
        this.otherSpecialPaxCount = 0;
        this.mailConsigner = null;
        this.mailConsignee = null;
        this.mailHanded = null;
        this.mailRefNo = null;

        // remarks
        this.remarks = null;

        // Flight Punctuality
        this.cleaningStartTime = null;
        this.cleaningCompletedTime = null;
        this.bordingClearenceTime = null;
        this.firstPaxBordingTime = null;
        this.lastPaxBordingTime = null;
        this.doorClosingTime = null;
        this.mailDeliveredAt = null;
        this.paxCount = null;
        this.briefingSrartTime = null;
        this.boardedToFirstBusTime = null;
        this.boardedToSecondBusTime = null;
        this.doorOpenedTime = null;
        this.landingTime = null;
        this.lastPaxDisembakedTime = null;
        this.pax = null;
        this.flightNo = null;
        this.landingSchdTime = null;
        this.lastPaxDisembakedSchdTime = null;
        this.doorOpenedSchdTime = null;

        this.breifingTime = null;
        this.cockpitCrewObTime = null;
        this.cabinCrewObTime = null;
        this.cabinFlightDelayCollection = null;
        this.briefingSrartSchdTime = null;
        this.breifingSchdTime = null;
        this.boardedToFirstBusSchdTime = null;
        this.boardedToSecondBusSchdTime = null;
        this.cockpitCrewObSchdTime = null;
        this.cabinCrewObSchdTime = null;
        this.cleaningStartSchdTime = null;
        this.cleaningCompletedSchdTime = null;
        this.firstPaxBordingSchdTime = null;
        this.lastPaxBordingSchdTime = null;
        this.doorClosingSchdTime = null;
        this.bordingClearenceSchdTime = null;
        this.sno1Required = false;
        this.sno2Required = false;
      }

        function OutBoundInfoCollection() {

            // Special service
            this.pregnantCount = 0;
            this.wchcCount = 0;
            this.deporteeCount = null
            this.otherSpecialPaxCount = 0;
            this.mailConsigner = null;
            this.mailConsignee = null;
            this.mailHanded = null;
            this.mailRefNo = null;

            // remarks
            this.remarks = null;

            // Flight Punctuality
            this.cleaningStartTime = null;
            this.cleaningCompletedTime = null;
            this.bordingClearenceTime = null;
            this.firstPaxBordingTime = null;
            this.lastPaxBordingTime = null;
            this.doorClosingTime = null;
            this.paxCount = null;
            this.mailDeliveredAt = null;
            this.briefingSrartTime = null;
            this.boardedToFirstBusTime = null;
            this.boardedToSecondBusTime = null;
            this.doorOpenedTime = null;
            this.breifingTime = null;
            this.cockpitCrewObTime = null;
            this.cabinCrewObTime = null;
            this.cabinFlightDelayCollection = null;
            this.briefingSrartSchdTime = null;
            this.breifingSchdTime = null;
            this.boardedToFirstBusSchdTime = null;
            this.boardedToSecondBusSchdTime = null;
            this.cockpitCrewObSchdTime = null;
            this.cabinCrewObSchdTime = null;
            this.cleaningStartSchdTime = null;
            this.cleaningCompletedSchdTime = null;
            this.firstPaxBordingSchdTime = null;
            this.lastPaxBordingSchdTime = null;
            this.doorClosingSchdTime = null;
            this.bordingClearenceSchdTime = null;
            this.sno1Required = false;
            this.sno2Required = false;
        }

        function DutyTabData() {
            this.pax = null;
            this.l1Cs = null;
            this.r1Cc = null;
            this.l4Cc = null;
            this.r4cCc = null;
            this.r3Cc = null;
            this.observer = null;
            this.observerId = null;
            this.extraCm = null;
            this.extraCmId = null;
            this.Capt = {
                role: "",
                signIn: "",
                signOut: ""
            };
            this.InboundFO = {
                role: "",
                signIn: "",
                signOut: ""
            };
            this.InboundSO = {
                role: "",
                signIn: "",
                signOut: ""
            };
            this.FO = {
                role: "",
                signIn: "",
                signOut: ""
            };
            this.InboundCapt = {
                role: "",
                signIn: "",
                signOut: ""
            };
            this.SCCML1 = {
                role: "",
                signIn: "",
                signOut: "",
                crewProfileId: ""
            };
            this.CCMR1 = {
                role: "",
                signIn: "",
                signOut: "",
                crewProfileId: ""
            };
            this.CCML4 = {
                role: "",
                signIn: "",
                signOut: "",
                crewProfileId: ""
            };
            this.CCMR4C = {
                role: "",
                signIn: "",
                signOut: "",
                crewProfileId: ""
            };
            this.CCMR3 = {
              role: "",
              signIn: "",
              signOut: "",
              crewProfileId: ""
            };
            this.Checker = {
                role: "",
                signIn: "",
                signOut: "",
                crewProfileId: ""
            };
            this.ExtraCCM = {
                role: "",
                signIn: "",
                signOut: "",
                crewProfileId: ""
            };
            this.Engineering = {
                role: "",
                signIn: "",
                signOut: "",
                crewProfileId: ""
            };
        }

        function SaveCabinRequest() {
            this.cabinFlightReportId = null;
            this.cabinFlightVersion = null;
            this.crewSchdBlockId = null;
            this.aircraftModel = null;
            this.crewPositions = null
            this.cateringSales = null;
            this.dutyFreeSales = null;
            this.fwdTrolly = null;
            this.aftTrolly = null;
            this.l1Cs = null;
            this.r1Cc = null;
            this.l4Cc = null;
            this.r4cCc = null;
            this.r3Cc = null;
            this.observer = null;
            this.observerId = null;
            this.extraCm = null;
            this.extraCmId = null;
            this.engineering = null;
            this.engineeringId = null;
            this.outGroundInfo = null;
            this.intGroundInfoCollection = null;
            this.inGroundInfo = null;
            this.remarkCollection = null;
            this.totalCateringSales = null;
            this.totalDutyFreeSales = null;
            this.totalOtherSalesAmount = null;
        }

        function FormatSearchParams(request) {
            var tmpData = new SearchCabinRequest();
            tmpData.fromDate = request.fromDate;
            tmpData.toDate = request.toDate;

            if (request.crewType) tmpData.crewTypeCode = request.crewType.crewTypeCode;
            else tmpData.crewTypeCode = null;
            if (request.origin) tmpData.origin = request.origin.airPortCode;
            else tmpData.origin = null;
            if (request.destination) tmpData.destination = request.destination.airPortCode;
            else tmpData.destination = null;
            if (request.crewDetails) {
                //tmpData.crewName = request.crewDetails.displayName;
                tmpData.crewId = request.crewDetails.crewId;
                tmpData.profileId = request.crewDetails.crewProfileId;
                tmpData.department = null;
            } else {
                //tmpData.crewName = null;
                tmpData.crewId = null;
                tmpData.department = null;
                tmpData.profileId = null;
            }

            if((!request.crewDetails ||request.crewDetails.length == 0)  && request.crewID !== null){
              tmpData.crewId = request.crewID;
            }

            if(!!request.department){
              tmpData.department = request.department.code;
            }

            if(!!request.approved){
              tmpData.approved = request.approved.value;
            }
            return tmpData;
        }

        function FormatEditPanelResponse(response) {
          var CabinFlightsData = {
              dutyTabData: {},
              flightReportsTabData: {},
              specialRemarksTabData: {},
              inBoundCrewCollection: [],
              outBoundCrewCollection: [],
              intBoundCrewCollection: []

          };

          CabinFlightsData.flightReportsTabData = FormatFlightReportTabData(response);
          angular.forEach(response.specialRemarkCollection, function(remark) {
              var txt = '';
              if (remark.crewTypeCode) txt = remark.crewTypeCode + ',';
              if (remark.createdDate) txt += remark.createdDate + ',';
              if (remark.createdTime) txt += remark.createdTime;
              remark.remarkInfo = txt;
          });
          CabinFlightsData.specialRemarksTabData = response.specialRemarkCollection;
          CabinFlightsData.dutyTabData = GetDutyTabDetails(response);
          CabinFlightsData.inBoundCrewCollection = response.inBoundCrewCollection;
          CabinFlightsData.intBoundCrewCollection = response.intBoundCrewCollection,
          CabinFlightsData.outBoundCrewCollection = response.outBoundCrewCollection;
          return CabinFlightsData;
        }

        function FormatFlightReportTabData(response) {

            var tempData = new FlightReportTabData();
            tempData.inBoundDate = response.inBoundDate;
            tempData.inBoundDestination = response.inBoundDestination;
            tempData.inBoundOrigin = response.inBoundOrigin;
            tempData.inBoundACReg = response.inBoundACReg;
            tempData.intermediateFlights = response.intermediateFlights;
            tempData.outBoundDate = response.outBoundDate;
            tempData.outBoundDestination = response.outBoundDestination;
            tempData.outBoundOrigin = response.outBoundOrigin;
            tempData.outBoundACReg = response.outBoundACReg;
            if (response.cateringSales) tempData.cateringSales = response.cateringSales;
            if (response.dutyFreeSales) tempData.dutyFreeSales = response.dutyFreeSales;
            if (response.fwdTrolly) tempData.fwdTrolly = response.fwdTrolly;
            if (response.aftTrolly) tempData.aftTrolly = response.aftTrolly;
            if (response.totalCateringSales) tempData.totalCateringSales = response.totalCateringSales;
            if (response.totalDutyFreeSales) tempData.totalDutyFreeSales = response.totalDutyFreeSales;
            if (response.totalOtherSalesAmount) tempData.totalOtherSalesAmount = response.totalOtherSalesAmount;
            tempData.totalTargetSales = response.totalCateringSales + response.totalDutyFreeSales + response.totalOtherSalesAmount;
            tempData.targetAchieved = !!tempData.totalTargetSales;

          if (response.inGroundInfoCollection) tempData.inBoundInfoCollection = GetInBoundInfoCollection(response.inGroundInfoCollection[0]);
            else tempData.inBoundInfoCollection = GetInBoundInfoCollection(response.inGroundInfoCollection);

            if (response.outGroundInfoCollection) tempData.outBoundInfoCollection = GetOutBoundInfoCollection(response.outGroundInfoCollection[0]);
            else tempData.outBoundInfoCollection = GetOutBoundInfoCollection(response.outGroundInfoCollection);

            if (response.intGroundInfoCollection) tempData.intGroundInfoCollection = GetIntBoundInfoCollection(response.intGroundInfoCollection);
            else tempData.intGroundInfoCollection = GetIntBoundInfoCollection(response.intGroundInfoCollection);

          formatIntermediateFlights(tempData);

          return tempData;
        }

        function formatIntermediateFlights(tempData) {
          angular.forEach(tempData.intermediateFlights, function(value, key){
            if(value.intGroundOrigin === tempData.outBoundOrigin){
              value.flag = 'Outbound';
            } else if(value.intGroundDestination === tempData.outBoundOrigin){
              value.flag = 'Inbound';
            } else {
              value.flag = 'Intermediate';
            }
          });
        }

        function GetInBoundInfoCollection(response) {
            var tempData = new InBoundInfoCollection();
            if (response) {
                //Special services
                if (response.pregnantCount || response.pregnantCount == 0){
                	tempData.pregnantCount = response.pregnantCount;
                }
                if (response.wchcCount || response.wchcCount == 0) {
                	tempData.wchcCount = response.wchcCount;
                }
                if (response.deporteeCount || response.deporteeCount == 0){
                	tempData.deporteeCount = response.deporteeCount;
                }
                if (response.otherSpecialPaxCount || response.otherSpecialPaxCount == 0) {
                	tempData.otherSpecialPaxCount = response.otherSpecialPaxCount;
                }
                tempData.mailConsigner = response.mailConsigner;
                tempData.mailConsignee = response.mailConsignee;
                tempData.mailHanded = response.mailHanded;
                tempData.mailRefNo = response.mailRefNo;

                //Remarks
                tempData.remarks = response.remarks;

                //Flight punctuality
                tempData.cleaningStartTime = response.cleaningStartTime;
                tempData.cleaningCompletedTime = response.cleaningCompletedTime;
                tempData.bordingClearenceTime = response.bordingClearenceTime;
                tempData.firstPaxBordingTime = response.firstPaxBordingTime;
                tempData.lastPaxBordingTime = response.lastPaxBordingTime;
                tempData.doorClosingTime = response.doorClosingTime;
                tempData.mailDeliveredAt = response.mailDeliveredAt;
                tempData.lastPaxDisembakedTime = response.lastPaxDisembakedTime;
                tempData.paxCount = response.paxCount;
                tempData.briefingSrartTime = response.briefingSrartTime;
                tempData.boardedToFirstBusTime = response.boardedToFirstBusTime;
                tempData.boardedToSecondBusTime = response.boardedToSecondBusTime;
                tempData.doorOpenedTime2 = response.doorOpenedTime2;
                tempData.doorOpenedTime = response.doorOpenedTime;
                tempData.landingTime = response.landingTime;
                tempData.lastPaxDisembakedTime2 = response.lastPaxDisembakedTime2;
                tempData.pax = 0;
                tempData.flightNo = response.flightNo;
                tempData.landingSchdTime = response.landingSchdTime;
                tempData.lastPaxDisembakedSchdTime = response.lastPaxDisembakedSchdTime;
                tempData.bordingClearenceSchdTime = response.bordingClearenceSchdTime;
                tempData.cleaningStartSchdTime = response.cleaningStartSchdTime;
                tempData.cleaningCompletedSchdTime = response.cleaningCompletedSchdTime;
                tempData.firstPaxBordingSchdTime = response.firstPaxBordingSchdTime;
                tempData.lastPaxBordingSchdTime = response.lastPaxBordingSchdTime;
                tempData.doorClosingSchdTime = response.doorClosingSchdTime;
                tempData.cabinFlightDelayCollection = response.cabinFlightDelayCollection;
                tempData.sno1Required = response.sno1Required;
                tempData.sno2Required = response.sno2Required;
            }
            return tempData;
        }

        function GetIntBoundInfoCollection(response) {
          var responseArray = [];
          if (response) {
            angular.forEach(response, function(value, key){
              var tempData = new IntBoundInfoCollection();
              //Special services
              if (value.pregnantCount || value.pregnantCount == 0){
                tempData.pregnantCount = value.pregnantCount;
              }
              if (value.wchcCount || value.wchcCount == 0) {
                tempData.wchcCount = value.wchcCount;
              }
              if (value.deporteeCount || value.deporteeCount == 0){
                tempData.deporteeCount = value.deporteeCount;
              }
              if (value.otherSpecialPaxCount || value.otherSpecialPaxCount == 0) {
                tempData.otherSpecialPaxCount = value.otherSpecialPaxCount;
              }
              tempData.mailConsigner = value.mailConsigner;
              tempData.mailConsignee = value.mailConsignee;
              tempData.mailHanded = value.mailHanded;
              tempData.mailRefNo = value.mailRefNo;

              //Remarks
              tempData.remarks = value.remarks;

              //Flight punctuality
              tempData.cleaningStartTime = value.cleaningStartTime;
              tempData.cleaningCompletedTime = value.cleaningCompletedTime;
              tempData.bordingClearenceTime = value.bordingClearenceTime;
              tempData.firstPaxBordingTime = value.firstPaxBordingTime;
              tempData.lastPaxBordingTime = value.lastPaxBordingTime;
              tempData.doorClosingTime = value.doorClosingTime;
              tempData.mailDeliveredAt = value.mailDeliveredAt;
              tempData.lastPaxDisembakedTime = value.lastPaxDisembakedTime;
              tempData.paxCount =  value.paxCount;
              tempData.briefingSrartTime = value.briefingSrartTime;
              tempData.boardedToFirstBusTime = value.boardedToFirstBusTime;
              tempData.boardedToSecondBusTime = value.boardedToSecondBusTime;
              tempData.doorOpenedTime2 = value.doorOpenedTime2;
              tempData.lastPaxDisembakedTime2 =  value.lastPaxDisembakedTime2
              tempData.breifingTime = value.breifingTime;
              tempData.cockpitCrewObTime = value.cockpitCrewObTime;
              tempData.cabinCrewObTime = value.cabinCrewObTime;

              tempData.briefingSrartSchdTime = value.briefingSrartSchdTime;
              tempData.breifingSchdTime = value.breifingSchdTime;
              tempData.boardedToFirstBusSchdTime = value.boardedToFirstBusSchdTime;
              tempData.boardedToSecondBusSchdTime = value.boardedToSecondBusSchdTime;
              tempData.cockpitCrewObSchdTime = value.cockpitCrewObSchdTime;
              tempData.cabinCrewObSchdTime = value.cabinCrewObSchdTime;

              tempData.landingTime = value.landingTime;
              tempData.lastPaxDisembakedTime = value.lastPaxDisembakedTime;
              tempData.pax = 0;
              tempData.flightNo = value.flightNo;
              tempData.landingSchdTime = value.landingSchdTime;
              tempData.lastPaxDisembakedSchdTime = value.lastPaxDisembakedSchdTime;
              tempData.bordingClearenceSchdTime = value.bordingClearenceSchdTime;
              tempData.cleaningStartSchdTime = value.cleaningStartSchdTime;
              tempData.cleaningCompletedSchdTime = value.cleaningCompletedSchdTime;
              tempData.firstPaxBordingSchdTime = value.firstPaxBordingSchdTime;
              tempData.lastPaxBordingSchdTime = value.lastPaxBordingSchdTime;
              tempData.doorClosingSchdTime = value.doorClosingSchdTime;
              tempData.cabinFlightDelayCollection = value.cabinFlightDelayCollection;
              tempData.sno1Required = value.sno1Required;
              tempData.sno2Required = value.sno2Required;

              responseArray.push(tempData);
            });

            return responseArray ;
          }


      }

        function GetOutBoundInfoCollection(response) {
            var tempData = new OutBoundInfoCollection();
            if (response) {
                //Special services
                if (response.pregnantCount || response.pregnantCount == 0){
                	tempData.pregnantCount = response.pregnantCount;
                }
                if (response.wchcCount || response.wchcCount == 0){
                	tempData.wchcCount = response.wchcCount;
                }
                if (response.deporteeCount || response.deporteeCount == 0) {
                	tempData.deporteeCount = response.deporteeCount;
                }
                if (response.otherSpecialPaxCount || response.otherSpecialPaxCount == 0){
                	tempData.otherSpecialPaxCount = response.otherSpecialPaxCount;
                }
                tempData.mailConsigner = response.mailConsigner;
                tempData.mailConsignee = response.mailConsignee;
                tempData.mailHanded = response.mailHanded;
                tempData.mailRefNo = response.mailRefNo;

                //Remarks
                tempData.remarks = response.remarks;

                //Flight punctuality
                tempData.cleaningStartTime = response.cleaningStartTime;
                tempData.cleaningCompletedTime = response.cleaningCompletedTime;
                tempData.bordingClearenceTime = response.bordingClearenceTime;
                tempData.firstPaxBordingTime = response.firstPaxBordingTime;
                tempData.lastPaxBordingTime = response.lastPaxBordingTime;
                tempData.doorClosingTime = response.doorClosingTime;
                tempData.paxCount = response.paxCount;
                tempData.mailDeliveredAt = response.mailDeliveredAt;
                tempData.briefingSrartTime = response.briefingSrartTime;
                tempData.boardedToFirstBusTime = response.boardedToFirstBusTime;
                tempData.boardedToSecondBusTime = response.boardedToSecondBusTime;
                tempData.doorOpenedTime = response.doorOpenedTime;
                tempData.breifingTime = response.breifingTime;
                tempData.cockpitCrewObTime = response.cockpitCrewObTime;
                tempData.cabinCrewObTime = response.cabinCrewObTime;
                tempData.briefingSrartSchdTime = response.briefingSrartSchdTime;
                tempData.breifingSchdTime = response.breifingSchdTime;
                tempData.boardedToFirstBusSchdTime = response.boardedToFirstBusSchdTime;
                tempData.boardedToSecondBusSchdTime = response.boardedToSecondBusSchdTime;
                tempData.cockpitCrewObSchdTime = response.cockpitCrewObSchdTime;
                tempData.cabinCrewObSchdTime = response.cabinCrewObSchdTime;
                tempData.cleaningStartSchdTime = response.cleaningStartSchdTime;
                tempData.cleaningCompletedSchdTime = response.cleaningCompletedSchdTime;
                tempData.firstPaxBordingSchdTime = response.firstPaxBordingSchdTime;
                tempData.lastPaxBordingSchdTime = response.lastPaxBordingSchdTime;
                tempData.doorClosingSchdTime = response.doorClosingSchdTime;
                tempData.bordingClearenceSchdTime = response.bordingClearenceSchdTime;
                tempData.cabinFlightDelayCollection = response.cabinFlightDelayCollection;
                tempData.pax = 0;
                tempData.paxCount = response.paxCount;
                tempData.flightNo = response.flightNo;
                tempData.sno1Required = response.sno1Required;
                tempData.sno2Required = response.sno2Required;
            }
            return tempData;
        }

        function GetDutyTabDetails(data) {
            var tempData = new DutyTabData();
            //tempData.pax = data.pax;
            tempData.l1Cs = data.l1Cs;
            tempData.r1Cc = data.r1Cc;
            tempData.l4Cc = data.l4Cc;
            tempData.r4cCc = data.r4cCc;
            tempData.r3Cc = data.r3Cc;
            //tempData.observer = data.observer;
            tempData.observerId = data.observerId;
            //data.extraCm = data.extraCm;
            tempData.extraCmId = data.extraCmId;
            //data.engineering = data.engineering;
            tempData.engineeringId = data.engineeringId;

            tempData.ExtraCCM.role = data.extraCm;

            tempData.ExtraCCM.crewProfileId = data.extraCmId;

            tempData.Checker.role = data.observer;

            tempData.Checker.crewProfileId = data.observerId;

            tempData.Engineering.crewProfileId = data.engineeringId;

            tempData.Engineering.role = data.engineering;

            return tempData;
        }

        function FormatEditPanelSaveRequest(request) {
            var tempData = new SaveCabinRequest();
            tempData.cabinFlightReportId = request.cabinFlightReportId;
            tempData.cabinFlightVersion = request.cabinFlightVersion;
            tempData.crewSchdBlockId = request.crewSchdBlockId;
            tempData.aircraftModel =  request.aircraftModel;
            tempData.crewPositions = request.crewPositions;

            //Duty
            tempData.l1Cs = request.dutyTabData.SCCML1.crewProfileId;
            tempData.r1Cc = request.dutyTabData.CCMR1.crewProfileId;
            tempData.l4Cc = request.dutyTabData.CCML4.crewProfileId;
            tempData.r4cCc = request.dutyTabData.CCMR4C.crewProfileId;
            tempData.r3Cc = request.dutyTabData.CCMR3.crewProfileId;
            tempData.observerId = request.dutyTabData.Checker.crewProfileId;
            tempData.extraCmId = request.dutyTabData.ExtraCCM.crewProfileId;
            tempData.engineeringId = request.dutyTabData.Engineering.crewProfileId;
            tempData.observer = request.dutyTabData.Checker.role;
            tempData.extraCm = request.dutyTabData.ExtraCCM.role;
            tempData.engineering = request.dutyTabData.Engineering.role;

            //Flight report
            tempData.cateringSales = request.flightReportsTabData.cateringSales;
            tempData.dutyFreeSales = request.flightReportsTabData.dutyFreeSales;
            tempData.fwdTrolly = request.flightReportsTabData.fwdTrolly;
            tempData.aftTrolly = request.flightReportsTabData.aftTrolly;
            tempData.outGroundInfo = GetOutBoundInfoCollection(request.flightReportsTabData.outBoundInfoCollection);
            tempData.inGroundInfo = GetInBoundInfoCollection(request.flightReportsTabData.inBoundInfoCollection);
            tempData.intGroundInfoCollection = GetIntBoundInfoCollection(request.flightReportsTabData.intGroundInfoCollection);

            if(request.flightReportsTabData.targetAchieved){
              tempData.totalCateringSales = request.flightReportsTabData.totalCateringSales;
              tempData.totalDutyFreeSales = request.flightReportsTabData.totalDutyFreeSales;
              tempData.totalOtherSalesAmount = request.flightReportsTabData.totalOtherSalesAmount;
            }

            //Special Remarks
            tempData.remarkCollection = request.specialRemarksTabData;
            return tempData;
        }
        return {
            formatSearchParams: FormatSearchParams,
            formatEditPanelResponse: FormatEditPanelResponse,
            formatEditPanelRequest: FormatEditPanelSaveRequest
        }
    }
})();
